import HeadingBlock from '$/components/global/heading';
import HeadingTab from '$/components/global/headingTab';
import DeclarationsPendingApproval from '$/pages/admin/compliance/pending-approval';
import { AppState } from '$/store';
import { getIsCurrentUserBixbyComplianceAdminState } from '$/store/profile/selectors';
import { getBixbyComplianceFeatureFlagState } from '$/store/release-feature-flags/selectors';
import { connect } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import './index.scss';

interface IAdminComplianceProps {
  isBixbyComplianceEnabled: boolean;
  isBixbyComplianceAdmin: boolean;
}

const AdminCompliance: React.FC<IAdminComplianceProps> = ({ isBixbyComplianceEnabled, isBixbyComplianceAdmin }) => {
  const baseUrl = `/admin/compliance`;

  return isBixbyComplianceEnabled && isBixbyComplianceAdmin ? (
    <div>
      <HeadingBlock title={'Compliance'}>
        <HeadingTab title="Pending Approval" link={`${baseUrl}/pending-approval`} />
      </HeadingBlock>
      <section className="compliance">
        <Routes>
          <Route path={'/'} element={<Navigate to={`${baseUrl}/pending-approval`} />} />
          <Route path={'/pending-approval'} element={<DeclarationsPendingApproval />} />
        </Routes>
      </section>
    </div>
  ) : (
    <Navigate to="/admin" />
  );
};

const mapStateToProps = (state: AppState) => {
  const { isBixbyComplianceEnabled } = getBixbyComplianceFeatureFlagState(state);
  const { isBixbyComplianceAdmin } = getIsCurrentUserBixbyComplianceAdminState(state);

  return {
    isBixbyComplianceEnabled,
    isBixbyComplianceAdmin,
  };
};

export default connect(mapStateToProps, null)(AdminCompliance);
